import { SimpleAutoCamera } from '@northladder/design-system';
import { TTextLocalized } from '@northladder/utilities';

/**
 * -----------------------------------------------------------------------------
 * Renders an SCG mask overlay for the front camera, showing an outline of a
 * person's face.
 */
function FrontCameraMaskOverlay() {
  return (
    <svg fill="none" viewBox="0 0 218 218" xmlns="http://www.w3.org/2000/svg">
      <path d="M4 4h210v210H4z" fill="#AAA" />
      <mask
        height={218}
        id="a"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'alpha' }}
        width={218}
        x={0}
        y={0}
      >
        <path
          d="M4 4h210v210H4z"
          fill="#000"
          stroke="#FAF5FF"
          strokeWidth={8}
        />
      </mask>
      <g mask="url(#a)">
        <path
          d="m109.08 17 .633.001c18.983.052 36.387 6.838 49.671 19.912 1.115 1.101 2.156 2.217 3.119 3.438.143.174.287.348.433.528 12.437 15.291 16.441 35.692 14.381 59.737-.542 4.471-1.39 8.886-2.483 13.263l-.164.651c-4.216 16.588-11.994 32.875-24.065 47.339-.399.47-.789.947-1.182 1.422a52.965 52.965 0 0 1-2.31 2.555 75.46 75.46 0 0 0-1.5 1.657c-.302.329-.302.329-.685.669-.422.449-.559.753-.73 1.333l-.165.549-.166.586-.176.603a51.36 51.36 0 0 0-1.269 5.786l-.112.689c-.614 5.11-.16 10.652 3.196 14.822l.389.449.352.408c1.783 1.897 4.063 2.817 6.508 3.569.806.251 1.609.514 2.406.777l.512.168c8.067 2.649 15.98 5.861 23.681 9.355l.39.176c4.89 2.217 9.742 4.49 14.459 7.045.575.312 1.153.622 1.729.932a162.407 162.407 0 0 1 11.339 6.743l.403.262c6.757 4.395 13.707 9.355 19.021 15.403.302.342.606.682.914 1.019 3.543 3.907 6.488 8.415 8.221 13.375l.132.37c.841 2.536 1.042 5.053 1.034 7.702l.003.958c.002.665.001 1.33-.001 1.991L236.996 283H-18.04s-1.166-9.295-.87-12.926c-.107-1.751-.092-3.513-.086-5.26.002-.706 0-1.414-.002-2.122-.002-2.968.021-5.937.835-8.829l.123-.442c1.436-4.884 4.274-9.148 7.566-13.037l.433-.528c1.37-1.64 2.888-3.137 4.428-4.621l.331-.323c1.186-1.157 2.388-2.292 3.658-3.344l.584-.494a86.424 86.424 0 0 1 4.774-3.701c.403-.294.803-.593 1.201-.892 4.525-3.344 9.338-6.387 14.247-9.186l.483-.278a227.47 227.47 0 0 1 6.642-3.663l.572-.304a236.37 236.37 0 0 1 16.923-8.172c.66-.287 1.32-.577 1.983-.868 4.948-2.179 9.973-4.17 15.055-6.03l.491-.179c.768-.28 1.538-.56 2.31-.834 2.291-.821 4.313-1.783 6.18-3.325.155-.122.308-.243.468-.367 3.408-2.799 5.371-6.988 5.853-11.271.343-4.095.012-10.294-2.734-13.676a18.915 18.915 0 0 0-.924-.869 27.96 27.96 0 0 1-2.657-2.837 24.418 24.418 0 0 0-1.113-1.249c-1.078-1.172-2.04-2.442-3.003-3.701-.297-.383-.597-.766-.9-1.148-11.358-14.464-19.02-32.122-24.257-62.742a106.5 106.5 0 0 0-.096-1.268c-1.051-14.39 1.213-29.493 7.759-42.455l.261-.52c2.407-4.716 5.391-9.074 8.972-13l.493-.545c2.118-2.291 4.312-4.508 6.815-6.405l.587-.468c9.145-7.27 20.407-11.497 31.959-13.3l.55-.086c3.678-.532 7.336-.69 11.051-.677l.175-.058Z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

interface IFrontCameraTestViewProps {
  cameraAccessErrorMessage: TTextLocalized;
  onCaptureSuccess: () => void;
}

/**
 * -----------------------------------------------------------------------------
 * Sets up a simple camera view for testing the front camera, which includes an
 * overlay
 */
export function FrontCameraTestView({
  cameraAccessErrorMessage,
  onCaptureSuccess,
}: IFrontCameraTestViewProps) {
  return (
    <div className="relative h-56 w-56">
      <SimpleAutoCamera
        cameraAccessErrorMessage={cameraAccessErrorMessage}
        className="h-[224px] w-[224px]"
        height={224}
        onCaptureSuccess={onCaptureSuccess}
        width={220}
      />

      <div
        className="
          pointer-events-none absolute left-0 top-0 h-full w-full opacity-100
          mix-blend-multiply
        "
      >
        <FrontCameraMaskOverlay />
      </div>
    </div>
  );
}
